import React, { useState } from "react";

import { RecoveryContainerFactoryImpl } from "../../../business";
import { AccountStrings } from "../../../business/core";
import { AccountContainerComponent } from "../components";

export const RecoveryAccessPage: React.FC = () => {
    const translate = AccountStrings['PTBR'].recovery;
    const [step, setStep] = useState(1);
    const [signupFormData, setSignupFormData] = useState<FormData>();
    const factory = new RecoveryContainerFactoryImpl(step, setStep, signupFormData, setSignupFormData);

    return (
        <AccountContainerComponent title={translate.title}>
            {factory.create()}
        </AccountContainerComponent>
    );
};
